<template>
  <ODialog ref="dialog">
    <v-card>
      <ODialogBar title="Associar Contato" @close="$refs.dialog.$dismiss()" />

      <v-card-text class="pa-6">
        <v-text-field
          v-model="keywords"
          placeholder="Buscar por email ou nome..."
          autofocus
          @keydown.up.prevent="move(-1)"
          @keydown.down.prevent="move(+1)"
          @keydown.enter="select()"
          :loading="isLoading"
          single-line
          hide-details
          class="ma-0 pa-0"
        />
      </v-card-text>

      <v-list dense>
        <v-list-item
          v-for="(item, index) in items"
          :key="item.id"
          :class="{ 'blue lighten-3': selIndex == index }"
          @mouseover="selIndex = index"
          @click="select()"
        >
          <v-list-item-action>
            <v-icon>mdi-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.fullName }}
              &mdash;
              <span class="grey--text">
                {{ item.email }}
              </span>
            </v-list-item-title>
            <v-list-item-subtitle>
              <OTagList :value="item.tags" />
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-card-text class="px-6 text-right">
        Se o contato desejado não está na lista, clique para
        <v-btn small @click="createNew">Criar um novo contato</v-btn>
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import _ from 'lodash'
import { Account } from '@/models'

export default {
  components: {},
  data() {
    return this.reset()
  },
  watch: {
    keywords() {
      this.debouncedFetchItems()
    }
  },
  created() {
    this.debouncedFetchItems = _.debounce(() => this.fetchItems(), 300)
  },
  methods: {
    reset() {
      return {
        keywords: null,
        isLoading: false,
        items: [],
        selIndex: null
      }
    },

    open() {
      Object.assign(this, this.reset())
      return this.$refs.dialog.$open()
    },

    async fetchItems() {
      this.$loading(async () => {
        let { rows: items } = await Account.findAll({
          keywords: this.keywords,
          limit: 5
        })

        this.items = items
      })
    },

    move(n) {
      if (this.items.length < 1) {
        this.selIndex = null
        return
      }

      let min = 0,
        max = this.items.length - 1

      if (this.selIndex == null) {
        if (n == +1) this.selIndex = 0
        if (n == -1) this.selIndex = max
      } else {
        this.selIndex += n
        if (this.selIndex > max) this.selIndex = min // loop
        if (this.selIndex < min) this.selIndex = max // loop
      }
    },

    select() {
      let item = null
      if (this.selIndex != null) item = this.items[this.selIndex]

      this.$refs.dialog.$apply(item)
    },

    createNew() {
      this.$refs.dialog.$apply('NEW')
    }
  }
}
</script>

<style></style>
